import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

export default function PaginaGrazie({ titolo, sottotitolo, bottone, immagine }) {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
      style={{ minHeight: '60vh', backgroundColor: '#ffffff' }}
    >
      <div className="text-center text-md-start col-md-6 mb-4 mb-md-0">
        <h1 className="fw-bold display-4 text-dark">{titolo}</h1>
        <p className="text-muted mt-3 fs-5">{sottotitolo}</p>
        <Button
          variant="outline-primary"
          className="mt-3 px-4 py-2"
          style={{ fontWeight: 600 }}
          onClick={() => navigate('/esplora-sondaggi')}
        >
          {bottone}
        </Button>
      </div>

      <div className="col-md-5 text-center">
        <img
          src={immagine}
          alt="Grazie per il feedback"
          className="img-fluid"
          style={{ maxHeight: '700px' }}
        />
      </div>
    </div>
  );
}
